function template(text) {
  return `<div class="modal-notice-container js-modal-to-hide">
            <div class="modal-notice">
              <p>${text}</p>
            </div>
          </div>`
}

export function addModalNotice(notice, useTemplate = false) {
  if (useTemplate) notice = template(notice)
  $('body').append(notice)
  notices()
}

export function addCustomAlertListeners() {
  Array.from(document.querySelectorAll('[data-custom-alert]'), el => {
    el.addEventListener('click', e => {
      e.preventDefault()
      exports.addModalNotice(template(el.getAttribute('data-custom-alert')))
    });
  });
}

export default function notices() {
  Array.from(document.querySelectorAll('.js-modal-to-hide'), el => {
    setTimeout(() => { el.style.display = 'none'; }, 3000);
  })
}
